import React from 'react';

const About = () => {
  return (
    <section id="about" className="section bg-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center">
            <p className="text-primary text-10 mb-1">Rovo Automation India pvt ltd.</p>
            <h2 className="font-weight-400 line-height-3 text-6">We deliver cutting-edge IoT integration and automation engineering services to global businesses.</h2>
          </div>
        </div>
        <div className="row justify-content-center mt-5">
          <div className="col-md-6 col-lg-4 mb-4 mb-lg-0">
            <div className="featured-box text-center">
              <div className="featured-box-icon mb-3">
                <img src="/images/projects/seamless integration.png" alt="IT Solutions" style={{width: '100%', maxWidth: '300px', height: '189px', borderRadius: '10px'}} />
              </div>
              <h3 className="font-weight-400">Seamless Integration</h3>
              <p className="text-black-70 text-2">Connecting Operational
                Technology—PLCs, SCADA, industrial
                robots—with Information Technology
                systems like ERP, MES, and CRM
                platforms</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 mb-4 mb-lg-0">
            <div className="featured-box text-center">
              <div className="featured-box-icon mb-3">
                <img src="/images/projects/real time data.png" alt="IoT Integration" style={{width: '100%', maxWidth: '300px', height: '189px', borderRadius: '10px'}} />
              </div>
              <h3 className="font-weight-400">Real-Time Data Flow</h3>
              <p className="text-black-70 text-2">Delivering continuous data streams
               from factory floor to management
                dashboards for instant visibility
                across operations
               </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="featured-box text-center">
              <div className="featured-box-icon mb-3">
                <img src="https://media.istockphoto.com/id/2157013127/photo/artificial-intelligence-machine-learning-natural-language-processing-data-technology.jpg?b=1&s=612x612&w=0&k=20&c=CeyLEqHF9FOohETNIt9IW5F0mIlg3iIh6OaH69FZdEQ=" alt="Automation Engineering" style={{width: '100%', maxWidth: '300px', height: 'auto', borderRadius: '10px'}} />
              </div>
              <h3 className="font-weight-400">Smart Decision-Making</h3>
              <p className="text-black-70 text-2">Enabling real-time insights that
empower faster, smarter decisions
to optimize manufacturing
performance</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
